import { channelFields } from "./formField/ChannelFormField";
import { useEffect, useState } from "react";
import { Button, Switch, FormControlLabel } from "@mui/material";
import { toast } from "../../../components/AppToast";
import { getChannelType } from "../../../services/channel/channel";
const CreateChannel = ({ initialValues, onCancel, onSubmit, viewOnly, isEdit }) => {
    const [ChannelTypee, setChannelType] = useState([]);
    const [formData, setFormData] = useState({
        channel_Id: "",
        channel_Name: "",
        channel_Type: "",
        channel_Link: "",
        apiUrl: [{ type: "", link: "", push: false, pull: false }],
        tenantId: ""
    });


    useEffect(() => {
        fetchChannelType();
    }, [])

    const fetchChannelType = async () => {
        const getChannelTypee = await getChannelType();
        setChannelType(getChannelTypee?.data?.data)
    }

    useEffect(() => {
        if ((viewOnly || isEdit) && initialValues) {
            setFormData({
                channel_Id: initialValues?.channel_Id,
                channel_Name: initialValues?.channel_Name,
                channel_Type: initialValues?.channel_Type,
                channel_Link: initialValues?.channel_Link,
                apiUrl: (initialValues.api_url || [{ type: "", link: "", push: false, pull: false }]).map(field => ({
                    type: field?.type || "",
                    link: field?.link || "",
                    push: field?.push || false,
                    pull: field?.pull || false,
                })),
                tenantId: initialValues.tenantId,
            });
        }
    }, [viewOnly, isEdit, initialValues]);


    // Handle changes for other fields
    const handleChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
    };


    const submit = async (e) => {
         e.preventDefault(); 
        try {
            const getUserDetails = JSON.parse(localStorage.getItem("persist:root"));
             if (!getUserDetails) {
            toast.error("User not logged in");
            return;
        }
            const loggedInUser = JSON.parse(getUserDetails.login);
            const finalData = {
                ...formData,
                tenantId: loggedInUser.userDetail.tenantId._id
            };

            if (isEdit) {
                await onSubmit(finalData, initialValues._id);
            } else {
                await onSubmit(finalData);
            }
        } catch (err) {
            if (err?.data?.message) {
                toast.error(err.data.data)
            } else {
                toast.error("Error saving channel");
            }
        }
    };

    // Handle changes for apiUrl children
    const handleApiChange = (index, field, value) => {
        const newApis = [...formData.apiUrl];
        newApis[index][field] = value;
        setFormData({ ...formData, apiUrl: newApis, });
    };

    // Add a new API entry
    const addApiField = () => {
        setFormData({
            ...formData,
            apiUrl: [...formData.apiUrl, { type: "", link: "", push: false, pull: false }],
        });
    };

    // Remove an API entry
    const removeApiField = (index) => {
        const newApis = [...formData.apiUrl];
        newApis.splice(index, 1);
        setFormData({ ...formData, apiUrl: newApis });
    };

    return (
        <form>
            <div className="d-flex flex-wrap gap-3">
                {channelFields.map((field) => (
                    <div
                        key={field.name}
                        style={{
                            flex: field.name === "apiUrl" ? "0 0 100%" : "0 0 23%",

                        }}
                        className="mb-3"
                    >
                        <div>
                            {field.name === "apiUrl" ? (
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div><label className="form-label">
                                        {field.label}
                                        {field.required && <span className="text-danger"> *</span>}
                                    </label></div>
                                    {!viewOnly && (<div>
                                        <Button variant="contained" size="small" onClick={addApiField}>
                                            + Add API
                                        </Button></div>)}

                                </div>
                            ) : (
                                <label className="form-label">
                                    {field.label}
                                    {field.required && <span className="text-danger"> *</span>}
                                </label>
                            )}
                        </div>



                        {field.name === "apiUrl" && (
                            <div
                                style={{
                                    marginTop: "6px",
                                    padding: "0.5rem",
                                    height: "fit-content",
                                    background: "#d3d3d35c",
                                    border: '1px solid lightgrey'
                                }}>

                                {formData.apiUrl.map((api, index) => (
                                    <div
                                        key={index}
                                        style={{
                                            display: 'flex', gap: '8px',
                                            paddingTop: index > 0 ? '0.5rem' : ''
                                        }}

                                    >

                                        <select style={{ width: '25%', lineHeight: '1.2' }}
                                            className="form-select "
                                            value={api.type}
                                            disabled={viewOnly}

                                            onChange={(e) => handleApiChange(index, "type", e.target.value)}
                                        >
                                            <option value="">Select Type</option>
                                            <option value="GET">GET</option>
                                            <option value="POST">POST</option>
                                            <option value="PUT">PUT</option>
                                        </select>


                                        <input
                                            type="text"
                                            className="form-control "
                                            placeholder="API Link"
                                            value={api.link}
                                            readOnly={viewOnly}
                                            onChange={(e) => handleApiChange(index, "link", e.target.value)}
                                            style={{ lineHeight: '1.2' }}
                                        />


                                        <div className="d-flex gap-2 ">


                                            {/* <label htmlFor={`sync-from-${index}`} className="form-check-label ms-2 mb-0" style={{ fontSize: 12, minWidth: 34 }}>
                                                <i className="bi bi-cloud-download me-1" style={{ fontSize: 12 }}></i>
                                                <span style={{ fontSize: 12, verticalAlign: 'middle' }}>Pull</span>
                                            </label> */}

                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        size="small"
                                                        disabled={viewOnly}
                                                        checked={api.push}
                                                        onChange={(e) => handleApiChange(index, "push", e.target.checked)}
                                                    />
                                                }
                                                label={
                                                    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                                        <i className="bi bi-cloud-upload" style={{ fontSize: 12 }}></i> {/* optional icon */}
                                                        Push
                                                    </span>
                                                }
                                            />


                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        size="small"
                                                        disabled={viewOnly}
                                                        checked={api.pull}
                                                        onChange={(e) => handleApiChange(index, "pull", e.target.checked)}
                                                    />
                                                }
                                                label={
                                                    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>
                                                         <i className="bi bi-cloud-download" style={{ fontSize: 12 }}></i>
                                                       
                                                        Pull
                                                    </span>
                                                }
                                            />

                                        </div>


                                        {!viewOnly && formData.apiUrl.length > 1 && (
                                            <Button
                                                style={{ height: '1%' }}
                                                variant="contained"
                                                color="error"
                                                size="small"
                                                onClick={() => removeApiField(index)}
                                            >
                                                -
                                            </Button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        )}



                        {field.name !== "apiUrl" && field.type === "text" && (
                            <input
                                type="text"
                                className="form-control"
                                value={formData[field.name] || ""}
                                required={field.required}
                                onChange={(e) => handleChange(field.name, e.target.value)}
                                readOnly={viewOnly}
                            />
                        )}

                        {field.name !== "apiUrl" && field.type === "select" && (
                            <select
                                className="form-select"
                                value={formData[field.name] || ""}
                                onChange={(e) => handleChange(field.name, e.target.value)}

                                disabled={viewOnly}
                            >
                                <option value="">Select</option>
                                {ChannelTypee.map((opt) => (
                                    <option key={opt.name} value={opt.name}>
                                        {opt.name}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>
                ))}
            </div>




            <div className="d-flex justify-content-center gap-2 mt-3">
                 <button className="btn btn-secondary" onClick={onCancel}>
                    Back
                </button>
                <button
                    className="btn btn-primary"
                    onClick={submit}

                    style={{ display: !viewOnly && !isEdit ? 'inline-flex' : 'none' }}
                >
                    Save
                </button>

              
                <button className="btn btn-primary"
                    onClick={submit}
                    style={{ display: isEdit && !viewOnly ? 'inline-flex' : 'none' }}
                >
                    Update
                </button>

            </div>
        </form>
    );
};

export default CreateChannel;

